import axios from "axios";

export const MessagesService = {
  count: async () => axios.get('admin/message/unread').then(res => res?.data)
}